import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PATH_REGION } from "../../../helper/mapPath";
import { getDistrictPath, getRegionPath } from "../../../helper";
import LangContext from "../../../contexts/LangContext";
import "./map.css";

const Nepal = (props) => {
  const { lang } = useContext(LangContext);

  const navigate = useNavigate();

  const showRegionInfo = useCallback((el) => navigate(getRegionPath(el.target.getAttribute("datapid"), el.target.getAttribute("datadid"), el.target.getAttribute("datarid")), { replace: true }), [navigate]);
  const showDistrictInfo = useCallback((el) => navigate(getDistrictPath(el.target.getAttribute("datapid"), el.target.getAttribute("datadid")), { replace: true }), [navigate]);

  const showMapLegend = (el) => {
    if (el.target.getAttribute("dataspecial")) {
      props.showMapLegendCandidate(null, null, null, el.target.getAttribute("dataspecial"));
    } else {
      let rid = el.target.id.split("-")[2];
      if (rid === "undefined") {
        rid = undefined;
      } else {
        rid = props.tab === "federal" ? parseFloat(rid).toFixed(0) : parseFloat(rid).toFixed(1);
      }

      if (rid) {
        props.showMapLegendCandidate(el.target.getAttribute("datapid"), el.target.getAttribute("datadid"), rid);
      } else {
        props.showMapLegend(el.target.getAttribute("datapid"), el.target.getAttribute("datadid"), "district");
      }
    }
  };

  const handleMouseMove = (el) => {
    props.handleMouseMove(el);
  };

  return (
    <div className="sh-nepal-district sh-nepal-federal">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="1225px" height="825px" viewBox="0 0 2550 1500" enableBackground="new 0 0 2550 1500" xmlSpace="preserve">
        <defs>
          <pattern id="pattern-national-park" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(45)">
            <line x1="0" y="0" x2="0" y2="6" stroke="#194d33" strokeWidth="10" />
          </pattern>
        </defs>
        {PATH_REGION.map((p, i) => {
          const provId = parseInt(p.id.split("-")[1]);
          const resultProv = props.result.provinces.length > 0 ? props.result.provinces.find((rp) => rp.id === provId) : null;

          return (
            <g className="sh-map-fg" id={p.id} key={i}>
              {p.districts.map((d, j) => {
                let opacity = 1;
                const resultDist = resultProv ? resultProv.districts.find((rd) => rd.id === d.id) : null;
                return (
                  <g className="" id={d.id} key={j}>
                    {d.regions.map((r, k) => {
                      if (k % 3 === 1) {
                        opacity = 1;
                      } else if (k % 3 === 2) {
                        opacity = 0.9;
                      } else {
                        opacity = 0.8;
                      }

                      const resultReg = resultDist ? resultDist.regions.find((rr) => rr.id === r.id) : null;

                      const sortedResult = resultReg ? resultReg.result.filter((r) => r.vote > 0).sort((x, y) => y.vote - x.vote) : null;

                      if (sortedResult && sortedResult[0] && sortedResult[0].elected) {
                        opacity = 1;
                      } else {
                        opacity = 0.8;
                      }

                      let party_code;
                      if (sortedResult && sortedResult[0]) {
                        party_code = sortedResult[0].party.match(/I+\d/) ? "I" : sortedResult[0].party;
                      }
                      let regTopParty = party_code ? props.parties.find((party) => party.code === party_code) : null;

                      return (
                        <g className="sh-district-region" key={k}>
                          {r.subregions.map((sr, l) => {
                            if (props.tab === "provincial") {
                              const resultReg = resultDist ? resultDist.regions.find((rr) => rr.id === sr.id) : null;

                              const sortedResult = resultReg ? resultReg.result.filter((r) => r.vote > 0).sort((x, y) => y.vote - x.vote) : null;

                              if (sortedResult && sortedResult[0] && sortedResult[0].elected) {
                                opacity = 1;
                              } else {
                                opacity = 0.8;
                              }
                              if (sortedResult && sortedResult[0]) {
                                party_code = sortedResult[0].party.match(/I+\d/) ? "I" : sortedResult[0].party;
                              }
                              regTopParty = party_code ? props.parties.find((party) => party.code === party_code) : null;

                              // for districts whose regions are not separated
                              if (sr.id === undefined) {
                                let winParties = [];
                                resultDist &&
                                  resultDist.regions.forEach((r) => {
                                    let res = r.result.filter((r) => r.vote > 0).sort((x, y) => y.vote - x.vote);
                                    if (res[0].elected) {
                                      const existParty = winParties.find((wp) => wp.party === res[0].party);
                                      if (existParty) {
                                        existParty.win += 1;
                                      } else {
                                        winParties.push({ party: res[0].party, win: 1 });
                                      }
                                    }
                                  });
                                winParties = winParties.sort((x, y) => y.win - x.win);
                                regTopParty = winParties[0] ? props.parties.find((party) => party.code === winParties[0].party) : null;
                                opacity = 1;
                              }
                            }

                            const style = { ...sr.style };

                            if (props.tab === "federal") {
                              style.strokeWidth = 1;
                              // style.strokeOpacity = 0.1;
                            }

                            // National Park data
                            if (sr.data) {
                              opacity = 1;
                            }
                            const fillColor = regTopParty ? regTopParty.color : "#d9f50a";
                            const strokeColor = r.style && r.style.strokeWidth ? fillColor : "#FFFFFF";
                            return (
                              <g key={l}>
                                <path
                                  id={"region-" + d.id + "-" + sr.id}
                                  style={style}
                                  className={"province-" + p.id + " district-" + d.id + " region-" + d.id + "-" + parseFloat(sr.id).toFixed(0)}
                                  stroke={strokeColor}
                                  fill={sr.data && sr.data.key === "NP" ? "url(#pattern-national-park)" : fillColor}
                                  d={sr.d}
                                  opacity={opacity}
                                  dataspecial={sr.data ? sr.data["value_" + lang] : ""}
                                  datapid={provId}
                                  datadid={d.id}
                                  datarid={parseFloat(sr.id).toFixed(0)}
                                  dataparty={party_code}
                                  onClick={!sr.data ? (!sr.id ? showDistrictInfo : showRegionInfo) : () => {}}
                                  onMouseOver={showMapLegend}
                                  onMouseMove={handleMouseMove}
                                ></path>
                              </g>
                            );
                          })}
                        </g>
                      );
                    })}
                  </g>
                );
              })}
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export default Nepal;
